import LogoWhite from "@assets/gc_logo_white.svg";

export function ParentPortalHoldingPage() {
	return (
		<main className="relative flex min-h-screen w-full items-center justify-center overflow-hidden bg-[#071d49] px-6 py-12 text-white">
			<div
				aria-hidden="true"
				className="absolute -right-28 -top-28 h-96 w-96 rounded-full bg-blue-400/15 blur-3xl"
			/>
			<div
				aria-hidden="true"
				className="absolute -bottom-40 -left-32 h-[30rem] w-[30rem] rounded-full bg-cyan-300/10 blur-3xl"
			/>

			<section className="relative w-full max-w-2xl text-center">
				<img
					src={LogoWhite}
					alt="Godalming College"
					className="mx-auto mb-14 h-auto w-56 max-w-[70vw]"
				/>

				<p className="mb-4 text-sm font-semibold uppercase tracking-[0.22em] text-blue-200">
					Parent Portal
				</p>
				<h1 className="text-4xl font-semibold tracking-tight sm:text-5xl">
					We&rsquo;ll be ready soon
				</h1>
				<p className="mx-auto mt-6 max-w-xl text-lg leading-8 text-blue-100">
					The portal is undergoing maintenance while we prepare for the new academic year.
				</p>

                <p className="mx-auto font-bold mt-6 max-w-xl text-lg leading-8 text-blue-100">
					If you're the parent of a student who left in Summer 2026 and you need to make a payment, click <a href="https://parents.godalming.ac.uk" className="text-blue-300 underline">here</a>.
				</p>

				<div className="mx-auto mt-12 h-px w-20 bg-blue-300/50" />
				<p className="mt-8 text-sm text-blue-200/80">
					Godalming College
				</p>
			</section>
		</main>
	);
}
